import React, { useEffect } from 'react';

import BaseLayout from 'apps/auth/components/common/Layout/BaseLayout';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import { PROFILE_EDIT_FORM_NAME } from 'apps/auth/constants/formName';
import { AUTH_SEND_MAIN_LINK } from 'apps/auth/constants/UrlConstants';
import { usePageMessages } from 'apps/auth/hooks/selectors';

interface VerifyAddressForm {
    errors?: Record<string, string>;
}

interface VerifyAddressInfoPageProps {
    onContinueClick: () => void;
    toggleSpinner: (isShow: boolean) => void;
    setFieldError: (formName: string, fieldName: string, error: unknown) => void;
    form?: VerifyAddressForm;
}

type VerifyAddressInfoMessages = {
    headerPurpleBlock?: string;
    headerText?: string;
    secondaryText?: string;
    continueButton?: string;
    notNowButton?: string;
};

export const VerifyAddressInfoPage: React.FC<VerifyAddressInfoPageProps> = ({ onContinueClick, toggleSpinner, setFieldError, form }) => {
    const { headerPurpleBlock, headerText, secondaryText, continueButton, notNowButton } = usePageMessages<VerifyAddressInfoMessages>() ?? {};

    useEffect(() => {
        const errors = form?.errors;
        if (errors && Object.keys(errors).length) {
            Object.keys(errors).forEach((name) => setFieldError(PROFILE_EDIT_FORM_NAME, name, errors[name]));
        }
    }, [form?.errors]);

    return (
        <BaseLayout>
            <InfoPage
                dataTestId="verify-address-info-page"
                topButtonType="link"
                iconName="id-card-attention-80"
                iconColor="primary"
                topButtonCaption={notNowButton}
                topButtonLink={AUTH_SEND_MAIN_LINK}
                topButtonOnClick={() => toggleSpinner(true)}
                headerText={
                    <>
                        <span>{headerPurpleBlock}</span>&nbsp;
                        {headerText}
                    </>
                }
                secondaryText={secondaryText}
                primaryButtonCaption={continueButton}
                primaryButtonOnClick={onContinueClick}
            />
        </BaseLayout>
    );
};

export default VerifyAddressInfoPage;
